<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <app-breadcrumb-v2 [titlePage]="textField.title" [count]="pageEvent.pageCount.toString()"></app-breadcrumb-v2>
      </div>
    </div>
    <div class="row clearfix">
      <div class="body">
        <div class="responsive_table">

          <p-messages [(value)]="message"></p-messages>
          <p-table #dt2
              dataKey="id"
              [value]="versetDuJourDataList"
              [paginator]="false"
              [rows]="pageEvent.rows"
              [loading]="isLoading"
              [showCurrentPageReport]="true"
              [globalFilterFields]="['code','description']"
              styleClass="p-datatable-gridlines" >

            <ng-template pTemplate="caption">
              <div class="table-header">
                <span class="p-input-icon-left">
                  <p-iconField iconPosition="left" class="ml-auto">
                    <p-inputIcon>
                        <i class="pi pi-search"></i>
                    </p-inputIcon>
                    <input pInputText [(ngModel)]="chantFilter.searchStr" id="searchStr"  (keyup.enter)="loadData()" type="text" placeholder="Search keyword" />
                  </p-iconField>
                  &nbsp;
                  <!-- <button (click)="showFormSearchAdvanced()" type="button" class="btn btn-primary"
                    pTooltip="{{enumText.SearchAdvanced}}" tooltipPosition="top">
                    <i class="pi pi-filter"></i>
                  </button> -->

                  <button *ngIf="initSearch" (click)="clear(0)" type="button" class="btn btn-outline"
                  pTooltip="{{enumText.ClearSearch}}" tooltipPosition="top">
                    <i class="pi pi-filter-slash"></i>
                  </button>
                </span>

                <span class="p-input-icon-left">
                  <button *ngIf="addButton" (click)="onAdd()" type="button" class="btn btn-primary">
                    <i class="fa fa-plus"></i> {{enumText.New}}
                  </button>
                </span>
              </div>
              <div style="padding-top: 10px;">
                <p-chip *ngIf="chantFilter.searchStr && chantFilter.searchStr!==''" label="{{chantFilter.searchStr}}" [removable]="true" (click)="clear(1)" />
              </div>
            </ng-template>

            <ng-template pTemplate="body" let-row>
              <tr>
                  <td class="cp" (click)="onEdit(row)">
                    <span class="pull-left stitre" style="margin-left:5px;">
                      <span class="db"><b>{{row.versesData?.bookData?.human}}  {{row.versesData?.chapitreReal}} : {{row.versesData?.versetReal}}</b></span>
                      <span class="db styleVerses"><i>{{row.versesData?.unformatted}}</i></span>
                      <span class="badge bg-green">{{row.dateDeclancheur | date:'EEEE dd MMM yyyy'}}</span>

                      <div class="{{commonService.badgeCS(row.actifYN)}}">
                        <i [class]="commonService.check(row.actifYN)"></i> actifYN
                      </div>
                    </span>

                    <span class="pull-right tr">
                      <p-button *ngIf="editButton" type="button" icon="pi pi-pencil" [outlined]="true" severity="secondary" (click)="onEdit(row)" />
                      <p-button *ngIf="deleteButton" type="button" icon="pi pi-trash" [outlined]="false" severity="danger" (click)="onDelete(row)" />
                    </span>
                  </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="2">{{enumText.NoDatafound}}...</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr>
                  <td colspan="10" style="padding: 0px;">
                    <div class="card1 flex1 justify-content-center">
                      <p-paginator
                          (onPageChange)="onPageChange($event)"
                          [first]="pageEvent.first"
                          [rows]="pageEvent.rows"
                          [totalRecords]="pageEvent.pageCount"
                          [rowsPerPageOptions]="[5, 10, 20, 30, 40, 50, 100]" />
                    </div>
                  </td>
              </tr>
            </ng-template>

          </p-table>
        </div>
      </div>
    </div>
  </div>
</section>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-toast position="top-center"></p-toast>
